import { minutesToMilliseconds } from "date-fns";

import { getCompanyBillingInfo } from "../../services";

export const companyBillingQuery = () => ({
	queryKey: ["get-billing-info-by-company"],
	queryFn: () => getCompanyBillingInfo(),
	staleTime: minutesToMilliseconds(2),
	meta: {
		errorMessage: "There was an error getting company billing info.",
	},
});
